import { createFileRoute, stripSearchParams, useNavigate } from '@tanstack/react-router'
import { useCallback } from 'react'

import { OrdersPage } from '@/components/DataVault/OrdersPage'
import {
  dataVaultSearchSchema,
  EMPTY_SEARCH,
  withoutDataVaultDefaults,
  type DataVaultSearch,
} from '@/components/DataVault/search'
import { inPageSearch, type SearchChangeOptions } from '@/lib/searchNavigation'

/** Wiring only. The schema lives beside the page in `search.ts`. */
export const Route = createFileRoute('/_app/data-vault/orders')({
  validateSearch: dataVaultSearchSchema,
  // A link to this page carries no defaults: the clean URL is the default view.
  search: { middlewares: [stripSearchParams(EMPTY_SEARCH)] },
  component: OrdersRoute,
})

function OrdersRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })
  const onSearchChange = useCallback(
    (next: Partial<DataVaultSearch>, options?: SearchChangeOptions) =>
      void navigate(inPageSearch(withoutDataVaultDefaults, next, options)),
    [navigate],
  )
  return <OrdersPage search={search} onSearchChange={onSearchChange} />
}
